/**
 * ms-whatsapp — botón flotante de WhatsApp (sections/ms-whatsapp.liquid).
 *
 * Custom element para que el editor de temas lo reinicie solo: cada vez que la
 * sección se vuelve a pintar, el navegador llama a connectedCallback. No hay
 * escuchas globales de `shopify:section:load` que limpiar.
 *
 * Hace tres cosas, y ninguna es necesaria para que el enlace funcione:
 *   1. Mide el alto REAL de la barra fija de compra y lo deja en
 *      `--ms-wa-atc-h`, para que el CSS levante el botón por encima de ella.
 *   2. Asoma la etiqueta a los 2 s y la retira a los 6 s, una vez por visita.
 *   3. Avisa el clic a la analítica de Shopify (evento `ms_whatsapp_click`).
 */
(function () {
  if (customElements.get('ms-whatsapp')) return;

  var CLAVE_VISTA = 'ms-wa-etiqueta-vista';

  class MsWhatsapp extends HTMLElement {
    connectedCallback() {
      this._timers = [];
      this._despejarBarraDeCompra();
      this._asomarEtiqueta();

      this._alClic = this._alClic.bind(this);
      var enlace = this.querySelector('[data-ms-wa-link]');
      if (enlace) enlace.addEventListener('click', this._alClic);
    }

    disconnectedCallback() {
      (this._timers || []).forEach(clearTimeout);
      this._timers = [];
      if (this._observador) {
        this._observador.disconnect();
        this._observador = null;
      }
      var enlace = this.querySelector('[data-ms-wa-link]');
      if (enlace && this._alClic) enlace.removeEventListener('click', this._alClic);
    }

    /* La barra fija de compra es única en la página y vive en otra sección:
       por eso se busca en el documento. Si está oculta mide 0 y el botón no se
       levanta. */
    _despejarBarraDeCompra() {
      var barra = document.querySelector('.sticky-add-to-cart');
      if (!barra) return;
      var yo = this;
      var medir = function () {
        var alto = barra.getBoundingClientRect().height;
        yo.style.setProperty('--ms-wa-atc-h', (alto > 0 ? alto + 12 : 0) + 'px');
      };
      medir();
      if ('ResizeObserver' in window) {
        this._observador = new ResizeObserver(medir);
        this._observador.observe(barra);
      }
    }

    _asomarEtiqueta() {
      var etiqueta = this.querySelector('[data-ms-wa-tip]');
      if (!etiqueta) return;

      var yaVista = false;
      try {
        yaVista = window.sessionStorage.getItem(CLAVE_VISTA) === '1';
      } catch (e) {
        yaVista = false;
      }
      if (yaVista) return;

      var yo = this;
      this._timers.push(
        setTimeout(function () {
          etiqueta.classList.add('ms-wa__tip--on');
          try {
            window.sessionStorage.setItem(CLAVE_VISTA, '1');
          } catch (e) {
            /* modo privado: se asoma en cada página y no pasa nada */
          }
          yo._timers.push(
            setTimeout(function () {
              etiqueta.classList.remove('ms-wa__tip--on');
            }, 4000)
          );
        }, 2000)
      );
    }

    _alClic() {
      try {
        if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
          window.Shopify.analytics.publish('ms_whatsapp_click', { pagina: window.location.pathname });
        }
      } catch (e) {
        /* la analítica nunca debe frenar el enlace */
      }
    }
  }

  customElements.define('ms-whatsapp', MsWhatsapp);
})();
